
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tattoo-from-photo-converter",
      function () {
        return require("private-next-pages/tattoo-from-photo-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tattoo-from-photo-converter"])
      });
    }
  